import { defaultIconMapping } from '@/config/iconMapping'

export const customerConfig = {
  images: {
    attachmentBg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMoAAADKCAQAAABObBcjAAABKklEQVR42u3RMQEAAACCMO1f2hoeIwJrdFctgCIoUAQFiqBAERRBgSIoUAQFiqAIChRBgSIoUARFUKAIChRBgSIoggJFUKAIChRBERQoggJFUKAIiqBAERQoggJFUAQFiqBAERQogiIoUAQFiqBAERRBgSIoUAQFiqAIChRBgSIoUARFUKAIChRBgSIoUCyAIihQBAWKoEARFEGBIihQBAWKoAgKFEGBIihQBEVQoAgKFEGBIiiCAkVQoAgKFEERFCiCAkVQoAiKoEARFCiCAkVQBAWKoEARFCiCIihQBAWKoEARFEGBIihQBAWKoAgKFEGBIihQBEVQoAgKFEGBIihQLIAiKFAEBYqgQBEUQYEiKFAEBYqgCAoUQYEiKFAERVCgCAoUQYGijwb7ZgDLHG6yNwAAAABJRU5ErkJggg==',
    avatarPlaceholder: require('@/assets/pictures/avatar_placeholder.png'),
    bodyBg: require('./assets/images/backgrounds/background.png'),
    errorBg: require('@/assets/pictures/error_background.jpg'),
    imagePlaceholder: require('@/assets/pictures/image_placeholder.png'),
    logo: require('./assets/images/logos/logo.png'),
    overlayBg: require('./assets/images/backgrounds/overlay_background.png'),
    scoresPageBg: undefined,
  },
}

const customIconMapping = {
  camera: 'mdi-camera-plus',
  chat_filled: 'mdi-email-outline',
  email_plus_outline: 'mdi-email-plus-outline',
  pen: 'mdi-pencil',
}
export const iconMapping = icon => { return customIconMapping[icon] || defaultIconMapping[icon] }
